export const configuration = {
    apiUrl: process.env.REACT_APP_API_URL,
    isProduction: process.env.REACT_APP_ENV === 'production',
    isDevelopment: process.env.REACT_APP_ENV === 'development',
    isDebugEnabled: process.env.REACT_APP_DEBUG === 'true'
};

export const keycloakSettings = {
    url: process.env.REACT_APP_KEYCLOAK_URL || '',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
    redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || ''
};
